import { observer } from "mobx-react";
import "./rma-list-page-new.scss";

const RmaListPageNew: React.FC = observer(() => {
    return <div className="rma-list-page-new" />;
});

export default RmaListPageNew;
